import React, { useState } from 'react';
import MaskedInput from 'react-text-mask';
import EyesOn from '@icons/eyes.svg';
import EyesOff from '@icons/eyes-hidden.svg';
import inputMask from '@utils/inputMask';
import { FieldBox, FieldDefault, FieldInvalid } from './Styled';

const Input = React.forwardRef((props, ref) => {
  const {
    label,
    name,
    mask,
    status,
    type,
    value,
    placeholder,
    required,
    onBlur,
    onChange,
    disabled,
    variant,
  } = props;

  const [dinamicType, setDinamicType] = useState(type);
  const isPasswordType = dinamicType === 'password';
  const isDefaultVariant = variant === 'outside-label';
  const idName = name || label.replace(/ /g, '-').toLowerCase();

  const toggleEyes = () => setDinamicType(isPasswordType ? 'text' : 'password');

  const buttonEyes = (
    <button type="button" onClick={toggleEyes}>
      {isPasswordType ? <EyesOn /> : <EyesOff />}
    </button>
  );

  const invalid = (
    <FieldInvalid invalidStatus={status} fieldDefault={isDefaultVariant}>
      {status}
    </FieldInvalid>
  );

  const fieldGroup = (
    <>
      <label htmlFor={idName}>{label}</label>
      <div>
        <MaskedInput
          type={dinamicType}
          id={idName}
          name={idName}
          value={value}
          ref={ref || null}
          guide={false}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          autoComplete="on"
          onBlur={onBlur}
          onChange={onChange}
          mask={mask ? inputMask(mask) : mask}
        />
        {type === 'password' ? buttonEyes : false}
      </div>
    </>
  );

  const fieldBox = <><FieldBox htmlFor={idName} hasError={!!status}>{fieldGroup}</FieldBox>{status ? invalid : false}</>;
  const fieldDefault = (
    <><FieldDefault disabled={disabled} hasError={!!status}>{fieldGroup}</FieldDefault>{status ? invalid : false}</>
  );

  return isDefaultVariant ? fieldDefault : fieldBox;
});

Input.defaultProps = {
  label: '',
  variant: 'outside-label',
  status: false,
  disabled: false,
  type: 'text',
  value: '',
  mask: [],
  placeholder: '',
  required: false,
  onBlur: (e) => e,
  onChange: (e) => e,
};

export default Input;
export { Input };
